<template>
	<div>
	<ppe-form 
		entityName="Company"
		:title="'B1. FICHE SIGNALETIQUE EE -'"
		title-field="{name}"
 	  sub-title="Entité intervenant"
		:schema="schema" :endpoint="endpoint"
		:redirect="this.getRedirectUrl()"
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
	</div>
</template>
<script>
import Utils    from '../ppe/utils'
 
export default {
	

	data() {
		return {
			values: {},
			endpoint : this.getApiUrl(),
			schema : [
				{
					card:"Etablissement / Entreprise",
					body:[
						{name:"name",       label:"Nom",     type: "text",     validation: 'required', size:'medium'},
						
						{name:"address",    label:"Adresse", type: "textarea", validation: 'required', size:'large'},

						{name:"zip",        label:"Code postal",             type: "number",   validation: 'required', size:'small'},
						{name:"city",       label:"Ville",                                     validation: 'required'},
						{name:"activity",   label:"Activité principale",     type: "text",     validation: 'required'},
						{name:"activity2",  label:"Activité secondaire", 	 type: "text",     validation: ''},
						{name:"qualifications",  label:"Qualifications", 	 type: "textarea", validation: ''},
						
						{name:"siret",   	label:"SIRET",                      type: "text",    validation: 'required', size:'small'},
						{name:"ape",   		label:"Code APE",                   type: "text",    validation: 'required', size:'small'},
						{name:"statut",     label:"Statut (SA, SAS, SARL, ..)", type: "text",    validation: 'required', size:'small'},
						{name:"nbemployees",label:"Nombre de personnels",       type: "number",  placeholder: 'Nombre',         size:'small'},
						
						{name:"website",    label:"Site web",                type: "text",     validation: '', size:'large'},
						]
				},
				{
					card:"Responsables",
					body:[
						{name:"companyOwner.name",   label:"Responsable de l'Entreprise Extérieure",  type: "text",   validation: 'required',   size: 'Medium'},
						{name:"companyOwner.phone",   label:"Portable",  type: "text",       validation: 'required',  size: 'small'},
						{name:"companyOwner.email",   label:"Email",  type: "text",          validation: 'required',  size: 'small'},
						
						{name:"securityOfficer.name",   label:"Responsable sécurité",  type: "text",     size: 'Medium'},
						{name:"securityOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
						{name:"securityOfficer.email",   label:"Email",  type: "text",     size: 'small'},

						{name:"covidOfficer.name",   label:"Responsable COVID 19",  type: "text",     size: 'Medium'},
						{name:"covidOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
						{name:"covidOfficer.email",   label:"Email",  type: "text",     size: 'small'},

						{name:"operationOfficer.name",   label:"Responsable des opérations",  type: "text",     validation: 'required',   size: 'Medium'},
						{name:"operationOfficer.phone",   label:"Portable",  type: "text",     validation: 'required',   size: 'small'},
						{name:"operationOfficer.email",   label:"Email",  type: "text",     validation: 'required',   size: 'small'},
					]
				},
				Utils.getAdminCard([
					{name:"isHost",     label:"Entreprise Utilisatrice ?", 			 type: "checkbox", validation: '', }
				]),

				],

		}
	},

	methods : {
		getCompanyId() {
			let companyId 
			if( this.$route.params.id) companyId = this.$route.params.id
			else companyId = this.$usermanager.user['company.id']
			return companyId
		},
		getRedirectUrl() {
			return "/ppe_ee/home/"+this.$usermanager.user._id
			//console.log("router.currentRoute.path", router.currentRoute.path)
      //return router.currentRoute.path
		},
		getApiUrl() {
			return "/ee/company?id="+this.getCompanyId()
		},
		onDataLoaded(data) {
			this.values = data.entity
		}
	}

};
</script>
<style>
</style>
 